<template>
  <v-container fluid>
    <PageTitle :title="'Workflow Designer - ' + flow.name" :showBackButton="true" />

    <v-card :loading="loading" :disabled="loading">
      <v-toolbar flat>
        <v-spacer></v-spacer>

        <v-btn icon @click="settingDialog = true" color="primary" title="Workflow settings">
          <v-icon>mdi-tune</v-icon>
        </v-btn>

        <v-btn icon title="Save" color="primary" @click="save">
          <v-icon>mdi-content-save-outline</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>

      <WorkflowDesigner
        v-model="actions"
        :types="types"
        @action-select="actionSelect"
      >
        <v-container>
          <v-row>
            <v-col cols="12">
              <TextBox
                v-if="editingAction"
                :config="{ title: 'Name', isRequired: true }"
                v-model="editingAction.name"
              />
            </v-col>
            <v-col cols="12">
              <TextArea
                v-if="editingAction"
                :config="{ title: 'Description', rows: 3 }"
                v-model="editingAction.description"
              />
            </v-col>
          </v-row>
        </v-container>
        <component
          v-if="editingAction"
          :is="editingAction.actionType + 'Designer'"
          v-model="editingAction"
        />
      </WorkflowDesigner>
    </v-card>

    <v-dialog v-model="settingDialog" scrollable :retain-focus="false" width="500">
      <ApiDataForm
        data-api="workflows"
        title="Edit Flow Settings"
        form-mode="edit"
        :can-save="true"
        :can-cancel="true"
        :filters="settingFilters"
        @after-save="afterSaveSetting"
        @cancel="settingDialog = false"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import server from "../../services/server";
import workflow_index from "../workflow/index_designer.js";
import ApiDataForm from "../ui/shared/ApiDataForm.vue";
import WorkflowDesigner from "../workflow/designer/WorkflowDesigner.vue";
import TextBox from "../ui/controls/TextBox.vue";
import TextArea from "../ui/controls/TextArea.vue";
import PageTitle from "../ui/shared/PageTitle.vue";

export default {
  name: "WorkflowDesign",

  components: {
    TextBox,
    TextArea,
    ApiDataForm,
    WorkflowDesigner,
    PageTitle,
    ...workflow_index.designers,
  },

  data() {
    return {
      flow: {},
      loading: false,
      settingDialog: false,
      actions: [],
      editingAction: null,
      types: workflow_index.actions,
    };
  },

  computed: {
    settingFilters() {
      return [
        {
          name: "flowId",
          compare: "=",
          value: this.$route.params.id,
        },
      ];
    },
  },

  async mounted() {
    this.loading = true;
    this.flow = await server.getItem("workflows", this.$route.params.id);

    if (this.flow.actions) {
      this.actions = JSON.parse(this.flow.actions);
    }

    this.loading = false;
  },

  beforeRouteLeave(to, from, next) {
    this.save();
    next();
  },

  methods: {
    save() {
      this.loading = true;

      server
        .put("workflows/update_action", this.flow.flowId, {
          actions: JSON.stringify(this.actions),
        })
        .catch((err) => {
          alert(err);
        })
        .finally(() => (this.loading = false));
    },
    afterSaveSetting(value) {
      this.flow.name = value.name;
      this.flow.callRoles = value.callRoles;
      this.settingDialog = false;
    },
    actionSelect({ selection }) {
      this.editingAction = selection;
    },
  },
};
</script>